import * as React from 'react';

import { createIcon } from '../Icon';
export const ToggleRightIcon = createIcon(
  <React.Fragment>
    <rect height={14} rx={7} ry={7} width={22} x={1} y={5} />
    <circle cx={16} cy={12} r={3} />
  </React.Fragment>,
  'ToggleRightIcon'
);
